import React from 'react';
import { SET_TUTORIAL_STATE, TUTORIAL_STATE_STORAGE_KEY } from '../../storage/TutorialReducer';
import Storage from '../../storage/Storage';
import TutorialManager from './TutorialManager';

export default class TutorialController extends React.Component {
  componentDidMount () {
    this.loadTutorialStateFromStorage();
  }

  loadTutorialStateFromStorage () {
    let tutorialState = this.getStateFromLocalStorage();

    if (!tutorialState) {
      return;
    }

    Storage.dispatch({type: SET_TUTORIAL_STATE, payload: tutorialState});
  }

  getStateFromLocalStorage () {
    const state = window.localStorage.getItem(TUTORIAL_STATE_STORAGE_KEY);

    if (state === null || state === undefined) {
      return null;
    }

    return JSON.parse(state);
  }

  render () {
    return (<TutorialManager/>);
  }
}



// WEBPACK FOOTER //
// ./src/components/Tutorial/TutorialController.js